/*
 * @Author: QIYE
 * @Date: 2020-06-05 11:42:58
 * @LastEditors: qiye
 * @LastEditTime: 2020-07-01 16:13:44
 */
const getters = {
  activeindex:state => state.user.activeindex,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js